module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/v2/welcome_to_tfl.d97a8f8c34899860038f5e13e14c69d0.svg";